export function initGtm(): void {
  if (!Array.isArray(window.dataLayer)) {
    return;
  }

  window.dataLayer.push({
    event: "baseline:new_frontend_runtime_ready",
    source: "build-runtime"
  });
}
